module.exports = __webpack_public_path__ + "static/media/icon-why-4.9dda13bc.svg";